import {
  packingTemplateIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import { PackingTemplateType } from "@redotech/redo-model/inventory/packing-template";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const PackingTemplateOptionSchema = z.object({
  id: packingTemplateIdFormat.schema,
  name: z.string(),
  templateType: createEnum(PackingTemplateType),
  unitsPerBox: z.number().int().positive().nullable(),
  isProductDefault: z.boolean(),
});

export type PackingTemplateOption = z.infer<typeof PackingTemplateOptionSchema>;

export const getPackingTemplatesForProduct = {
  name: "getPackingTemplatesForProduct" as const,
  input: z.object({ productId: productIdFormat.schema }),
  output: z.object({ templates: z.array(PackingTemplateOptionSchema) }),
};
